'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _typeToReducer2 = require('type-to-reducer');

var _typeToReducer3 = _interopRequireDefault(_typeToReducer2);

var _types = require('shared/modules/App/types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  backgroundImages: [],
  text: {
    keepInMind: {
      education: {
        title: 'Nearby training and education providers',
        text: 'There are number of institutions in the New York area that offer programs specializing in Financial Service.',
        linkText: 'Learn more about New York trainers and educators.',
        href: '/list/where-to-get-training'
      },
      employers: {
        title: 'Ready to see who is hiring?',
        text: 'New York City and the surrounding areas are the worldwide hub for Financial Services.',
        linkText: 'See some of the primary companies in and around New York.',
        href: '/list/who-is-hiring'
      },
      advising: {
        title: 'Need help getting a job?',
        text: 'If you need to ask some questions or get some help figuring out how to pursue, a handful of community based organizations are here to help.',
        linkText: 'Find a nearby advising organization.',
        href: '/list/advisors'
      }
    },
    costComparison: {
      annualText: 'Average annual cost: ',
      averageSalaryText: 'Average salary after attending: '
    }
  }
};
//import arrayAsObj from 'shared/utils/arrayAsObj';

exports.default = (0, _typeToReducer3.default)((0, _defineProperty3.default)({}, _types.GET_APP, {
  FULFILLED: function FULFILLED(state, _ref) {
    var response = _ref.response;
    var backgrounds = response.backgrounds;


    return (0, _extends3.default)({}, state, {
      backgroundImages: backgrounds
    });
  }
}), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/reducers/content/index.js
// module id = 1283
// module chunks = 0